import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import Layout, { LayoutContent, LayoutFooter } from '~/App/components/Layout'
import useFinishFlow from '~/App/Flow/hooks/useFinishFlow'
import StoreLayoutHeader from '~/App/Store/components/StoreLayoutHeader'
import useCloseStore from '~/App/Store/hooks/useCloseStore'
import { Button } from '~/DesignSystem/components/button'

const SurveySuccessPage: React.FC = () => {
  const { mutate: finishFlow, isPending: finishingFlow } = useFinishFlow()
  const close = useCloseStore()

  useEffect(() => {
    finishFlow()
  }, [])

  return (
    <Layout>
      <StoreLayoutHeader />
      <LayoutContent className="flex items-center justify-center text-center">
        <p className="text-lg">
          <FormattedMessage id="survey.success" />
        </p>
      </LayoutContent>
      <LayoutFooter>
        <Button size="xl" className="w-full" onClick={close} disabled={finishingFlow}>
          <FormattedMessage id="modal.actions.close" />
        </Button>
      </LayoutFooter>
    </Layout>
  )
}

export default SurveySuccessPage
